import { render, staticRenderFns } from "./ReCardServiceAdd.vue?vue&type=template&id=58652188&scoped=true"
import script from "./ReCardServiceAdd.vue?vue&type=script&lang=js"
export * from "./ReCardServiceAdd.vue?vue&type=script&lang=js"
import style0 from "./ReCardServiceAdd.vue?vue&type=style&index=0&id=58652188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58652188",
  null
  
)

export default component.exports